if (!customElements.get('product-snippet')) {
  customElements.define(
    'product-snippet',
    class ProductSnippet extends HTMLElement {
      constructor() {
        super();
        this.isDrawerInitialized = false;
        this.mobileOptionsClone = null;
        this.drawerClone = null;
        this.lastWindowWidth = window.innerWidth;
      }

      connectedCallback() {
        this.init(); // Call init when element is connected to the DOM
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
        }
      }

      init() {
        this.threshold = this.getAttribute('new-threshold-days');
        this.thresholdPercentage = this.getAttribute('threshold-percentage');
        this.createdAt = this.getAttribute('created-at');
        this.product = JSON.parse(this.querySelector('#p-data').innerHTML);
        window.addEventListener('resize', this.onResize.bind(this));
        this.handleVariantDrawer(); // Handle the variant drawer behavior
      }

      onResize() {
        const currentWindowWidth = window.innerWidth;

        // Run handleVariantDrawer only if there's a significant resize (e.g., switching between mobile and desktop views)
        if (
          (this.lastWindowWidth >= 960 && currentWindowWidth < 960) ||
          (this.lastWindowWidth < 960 && currentWindowWidth >= 960)
        ) {
          this.lastWindowWidth = currentWindowWidth;

          // Remove any existing clones and reset the flags before re-initializing
          if (this.drawerClone) {
            this.drawerClone.remove();
            this.drawerClone = null;
          }
          if (this.mobileOptionsClone) {
            this.mobileOptionsClone.remove();
            this.mobileOptionsClone = null;
          }

          document.body.classList.remove('overflow-hidden');
          this.isDrawerInitialized = false; // Reset the drawer initialized flag

          this.handleVariantDrawer(); // Re-run drawer setup after resize
        }
      }

      initSwiper() {
        const swiperElement = document.querySelector(
          `.variants-drawer--open .js-mobile-swiper-${this.product.data.id}`
        );
        if (!swiperElement) return; // Ensure the swiper element exists
        // eslint-disable-next-line no-new, no-undef
        this.swiper = new Swiper(swiperElement, {
          slidesPerView: '1',
          pagination: {
            el: document.querySelector('.variants-drawer--open .swiper-pagination'),
            dynamicBullets: true,
          },
        });
      }

      initSwiper() {
        const swiperElement = document.querySelector(
          `.variants-drawer--open .js-mobile-swiper-${this.product.data.id}`
        );
        if (!swiperElement) return; // Ensure the swiper element exists
        // eslint-disable-next-line no-new, no-undef
        this.swiper = new Swiper(swiperElement, {
          slidesPerView: '1',
          pagination: {
            el: document.querySelector('.variants-drawer--open .swiper-pagination'),
            dynamicBullets: true,
          },
        });
      }

      resetProductFormState() {
        const { productForm } = this;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      updateOptionValues(html) {
        const existingVariantSelects = this.querySelectorAll('variant-selects');
        // Get all new variant-selects from the new HTML content
        const newVariantSelects = html.querySelectorAll('variant-selects');

        // Loop through all elements and replace each one
        existingVariantSelects.forEach((existingVariantSelect, index) => {
          const newVariantSelect = newVariantSelects[index];

          // Replace the old variant-select with the new one using viewTransition
          HTMLUpdateUtility.viewTransition(existingVariantSelect, newVariantSelect, this.preProcessHtmlCallbacks);
        });
        this.handleRadioChange();
      }

      handleRadioChange(node) {
        node.querySelectorAll('.option-row input[type="radio"]').forEach((input) => {
          // input.addEventListener('change', (event) => {
          //   event.stopPropagation();
          //   if (event.target === input) {
          //     // Find the current clicked input element
          //     const currentInput = event.target;
          //     console.log(currentInput.id);
          //     // Remove 'active-choice' class from all labels
          //     node.querySelectorAll('.option-row label').forEach((label) => {
          //       label.classList.remove('active-choice');
          //     });
          //     // Add 'active-choice' class to the label associated with the clicked input
          //     const associatedLabel = node.querySelector(`label.${currentInput.id}`);
          //     if (associatedLabel) {
          //       associatedLabel.classList.add('active-choice');
          //     }
          //   }
          // });
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues, privateEventId } }) {
        if (privateEventId === `product-card-${this.product.data.id}`) {
          const productUrl = `/products/${this.product.data.handle}`;
          this.resetProductFormState();
          const requestUrl = this.buildRequestUrlWithParams(productUrl, selectedOptionValues);
          this.abortController = new AbortController();

          fetch(requestUrl, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((responseText) => {
              this.pendingRequestUrl = null;
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const variant = this.getSelectedVariant(html);
              this.drawerClone.querySelector('variant-selects').innerHTML =
                html.querySelector('product-info variant-selects').innerHTML;
              this.drawerClone.querySelector('.variant-drawer__price').innerHTML =
                html.querySelector('product-info .main_price').innerHTML;
              // this.drawerClone.querySelector(".variant-drawer__compared-price").innerHTML = html.querySelector("product-info .compare_at_price").innerHTML;

              // Invalid element so need to comment for now ...
              /* this.drawerClone.querySelector('.variant-drawer__offer').innerHTML = html.querySelector(
                'product-info .product__offer-text'
              ).innerHTML; */

              this.drawerClone.querySelector('.product-variant-id').value = variant.id;
              this.productForm.toggleSubmitButton(
                html.querySelector(`.btn_cta`)?.hasAttribute('disabled') ?? true,
                window.variantStrings.soldOut
              );
            })
            .then(() => {
              // set focus to last clicked option value
              this.querySelector(`#${target.id}`)?.focus();
            })
            .catch((error) => {
              if (error.name === 'AbortError') {
                console.log('Fetch aborted by user');
              } else {
                console.error(error);
              }
            });
        }
      }

      handleMobileOptionValueChange({ data: { event, target, selectedOptionValues, privateEventId } }) {
        if (privateEventId === `product-card-${this.product.data.id}`) {
          const productUrl = `/products/${this.product.data.handle}`;
          this.resetProductFormState();
          const requestUrl = this.buildRequestUrlWithParams(productUrl, selectedOptionValues);
          this.abortController = new AbortController();

          fetch(requestUrl, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((responseText) => {
              this.pendingRequestUrl = null;
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const variant = this.getSelectedVariant(html);
              this.mobileOptionsClone.querySelector('variant-selects').innerHTML = html.querySelector(
                '.atc-mobile__options-list variant-selects'
              ).innerHTML;
              this.mobileOptionsClone.querySelector('.product-variant-id').value = variant.id;
              this.productForm.toggleSubmitButton(
                html.querySelector(`.btn_cta`)?.hasAttribute('disabled') ?? true,
                window.variantStrings.soldOut
              );
              this.handleSeeMoreOptionsButton(this.mobileOptionsClone);
            })
            .then(() => {
              // set focus to last clicked option value
              this.querySelector(`#${target.id}`)?.focus();
            })
            .catch((error) => {
              if (error.name === 'AbortError') {
                console.log('Fetch aborted by user');
              } else {
                console.error(error);
              }
            });
        }
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      buildRequestUrlWithParams(url, optionValues) {
        const params = [];

        // params.push(`sections=template--23234586476879__main`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      handleOptionsMenu(node) {
        const overlayOptions = node.querySelector('.atc-mobile__options-overlay');
        const closeButton = node.querySelector('.atc-mobile__options-close-icon');

        // close options menu
        if (overlayOptions && closeButton) {
          [overlayOptions, closeButton].forEach((closeElement) => {
            closeElement.addEventListener('click', (event) => {
              event.stopPropagation(); // Prevent the event from propagating to optionsButton
              node.classList.remove('atc-mobile__options--open');
              document.body.classList.remove('overflow-hidden');
              this.mobileOptionsClone = null;
              node.remove();
            });
          });
        }
      }

      handleSeeMoreOptionsButton(node) {
        const seeMoreBtn = node.querySelector('.options-rows__see-more-btn');
        if (seeMoreBtn) {
          seeMoreBtn.addEventListener('click', () => {
            const optionsRows = node.querySelector('.product-form__input.option-rows');
            optionsRows.style.overflowY = 'auto';
            seeMoreBtn.style.display = 'none';
          });
        }
      }

      handleVariantDrawer() {
        const btnVariant = this.querySelector('.btn_variant');
        const isMobile = window.innerWidth < 960;

        if (isMobile && !this.mobileOptionsClone) {
          const mobileOptionsWrapper = this.querySelector('.product-form-mobile');
          if (btnVariant && mobileOptionsWrapper) {
            btnVariant.addEventListener('click', (event) => {
              event.stopPropagation();
              event.preventDefault();
              if (this.mobileOptionsClone) return;

              this.mobileOptionsClone = mobileOptionsWrapper.cloneNode(true);
              this.mobileOptionsClone.querySelector('variant-selects').init();
              this.productForm = this.mobileOptionsClone;
              document.body.appendChild(this.mobileOptionsClone);
              document.body.classList.add('overflow-hidden');
              this.onVariantChangeUnsubscriber = subscribe(
                PUB_SUB_EVENTS.optionValueCardMobileSelectionChange,
                this.handleMobileOptionValueChange.bind(this)
              );
              this.mobileOptionsClone
                .querySelector('.atc-mobile__options-wrapper')
                .classList.add('atc-mobile__options--open');
              this.handleOptionsMenu(this.mobileOptionsClone.querySelector('.atc-mobile__options-wrapper'));
              this.handleSeeMoreOptionsButton(this.mobileOptionsClone.querySelector('.atc-mobile__options-wrapper'));
              this.handleRadioChange(this.mobileOptionsClone.querySelector('.atc-mobile__options-wrapper'));
            });
          }
        } else if (!isMobile && !this.drawerClone) {
          const variantsDrawer = this.querySelector('.product_card__variants-drawer');
          if (btnVariant && variantsDrawer) {
            btnVariant.addEventListener('click', (event) => {
              event.stopPropagation();
              event.preventDefault();
              if (this.drawerClone) return;

              this.drawerClone = variantsDrawer.cloneNode(true);
              document.body.appendChild(this.drawerClone);
              document.body.classList.add('overflow-hidden');

              this.drawerClone.classList.add('variants-drawer--open');
              this.initSwiper();
              this.productForm = this.drawerClone.querySelector('product-form');

              // Add event listener for form submission
              if (this.productForm && this.productForm.form) {
                this.productForm.form.addEventListener('submit', this.handleFormSubmit.bind(this));
              }

              this.onVariantChangeUnsubscriber = subscribe(
                PUB_SUB_EVENTS.optionValueCardSelectionChange,
                this.handleOptionValueChange.bind(this)
              );
              requestAnimationFrame(() => {
                this.drawerClone.querySelector('.variants-drawer__wrapper').style.transform = 'translate(0)';
              });

              const overlayDrawer = this.drawerClone.querySelector('.product_card__variants-overlay');
              const xClose = this.drawerClone.querySelector('.x-close-icon');
              [overlayDrawer, xClose].forEach((element) => {
                element.addEventListener('click', () => {
                  this.closeVariantDrawer();
                });
              });
            });
          }
        }
      }

      closeVariantDrawer() {
        if (!this.drawerClone) return;

        this.drawerClone.querySelector('.variants-drawer__wrapper').style.transform = 'translate(100%)';
        setTimeout(() => {
          if (this.onVariantChangeUnsubscriber) {
            this.onVariantChangeUnsubscriber();
          }
          this.drawerClone.remove();
          this.drawerClone = null;
          document.body.classList.remove('overflow-hidden');
        }, 200);
      }

      handleFormSubmit() {
        // We don't need to prevent default here as the ProductForm class already does that
        // This method ensures the drawer is properly closed after form submission
        setTimeout(() => {
          this.closeVariantDrawer();
        }, 500); // Add a small delay to allow the cart to update first
      }
    }
  );
}
